import React from "react";
import { Navigate } from "react-router-dom";

/**
 * ProtectedRoute - Role-based route protection component
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if authorized
 * @param {string[]} props.allowedRoles - Array of allowed AdminType values (e.g., ["Supper", "Admin", "CallCenter"])
 * @param {string} props.redirectTo - Optional redirect path if unauthorized (defaults to "/users")
 */
const ProtectedRoute = ({ children, allowedRoles = [], redirectTo = "/users" }) => {
  const token = localStorage.getItem("token");
  const IsAdmin = localStorage.getItem("IsAdmin");
  const AdminType = localStorage.getItem("AdminType");

  // If no token, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If not an admin, redirect to login
  if (!IsAdmin) {
    return <Navigate to="/login" replace />;
  }

  // If no AdminType, redirect to login
  if (!AdminType) {
    return <Navigate to="/login" replace />;
  }

  // Check if user's role is in the allowed roles list
  if (allowedRoles.length > 0 && !allowedRoles.includes(AdminType)) {
    // Redirect based on role
    if (AdminType === "CallCenter") {
      return <Navigate to="/users" replace />;
    } else if (AdminType === "Team") {
      return <Navigate to="/users" replace />;
    } else {
      return <Navigate to={redirectTo} replace />;
    }
  }

  // User is authorized, render the protected component
  return children;
};

export default ProtectedRoute;
